import * as React from 'react';
import Paper from '@mui/material/Paper';
import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {useTranslation} from 'react-i18next';

export default function CompliencePage(): React.ReactElement {
    const {t} = useTranslation();

    const Item = styled(Paper)(({theme}) => ({
        ...theme.typography.body2,
        padding: theme.spacing(3),
        backgroundColor: "#fffcf8",
        //marginLeft: 20,
        marginRight: 20,
        marginBottom: 20,
        textAlign: 'center',
        border: 'none',
        borderRadius: 0,
        boxShadow: '0',
        color: theme.palette.text.secondary,
        ...theme.applyStyles('dark', {
            backgroundColor: 'grey',
        }),
    }));

    return (
        <Grid container>
            <Grid size={12}>
                <Item>
                    <Box sx={{width: '100%', bgcolor: '#fffcf8'}}>
                        {t('complience.placeholder.hello')}
                    </Box>
                </Item>
            </Grid>
        </Grid>
    )
}